<div class="container">
  <h1>
    {{ 'utilisateur.recherche.titrePage' | translate }}
  </h1>

  <div class="form-container">
    <form [formGroup]="form"
      (ngSubmit)="rechercher()">
      <div class="inputs-container">
        <!-- Nom -->
        <mat-form-field appearance="fill">
          <mat-label>{{ 'utilisateur.recherche.form.nom' | translate }}</mat-label>
          <input matInput
            formControlName="nom">
        </mat-form-field>

        <!-- Prénom -->
        <mat-form-field appearance="fill">
          <mat-label>{{ 'utilisateur.recherche.form.prenom' | translate }}</mat-label>
          <input matInput
            formControlName="prenom">
        </mat-form-field>
      </div>

      <div *ngIf="!form.pristine && form.touched">
        <div class="invalid-feedback"
          *ngFor="let entry of form.errors | keyvalue">
          {{entry.value.message}}
        </div>
      </div>

      <!-- Boutons -->
      <div class="buttons-container">
        <button mat-raised-button
          color="secondary"
          type="button"
          class="me-2"
          (click)="reinitialiser()">
          {{ 'sigt.global.boutons.reinitialiser' | translate }}
        </button>

        <button mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!form.valid">
          {{ 'sigt.global.boutons.rechercher' | translate }}
        </button>
      </div>
    </form>
  </div>

  <div class="table-container mb-3">
    <table mat-table
      [dataSource]="dataSource"
      (matSortChange)="trier($event)"
      matSort
      matSortActive="nomComplet"
      matSortDirection="asc"
      class="mat-elevation-z8">
      <!-- Code IDZ -->
      <ng-container matColumnDef="codeUtilIdz">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="codeUtilIdz"> {{ 'utilisateur.recherche.grille.code' | translate }} </th>
        <td mat-cell
          *matCellDef="let element"> {{ element.codeUtilIdz }} </td>
      </ng-container>

      <!-- Nom -->
      <ng-container matColumnDef="nomComplet">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="nomComplet"> {{ 'utilisateur.recherche.grille.nom' | translate }} </th>
        <td mat-cell
          *matCellDef="let element"> {{ element.nomComplet }} </td>
      </ng-container>

      <!-- Telephone -->
      <ng-container matColumnDef="telephone">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="telephone"> {{ 'utilisateur.recherche.grille.telephone' | translate }} </th>
        <td mat-cell
          *matCellDef="let element"> {{ element.telephone }} </td>
      </ng-container>

      <!-- directionEmployeur -->
      <ng-container matColumnDef="nomDirectionOuEmployeur">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="nomDirectionOuEmployeur">{{ 'utilisateur.recherche.grille.directionEmployeur' | translate }}
        </th>
        <td mat-cell
          *matCellDef="let element"> {{ element.nomDirectionOuEmployeur }} </td>
      </ng-container>

      <!-- Courriel -->
      <ng-container matColumnDef="adrCourriel">
        <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header="adrCourriel">{{ 'utilisateur.recherche.grille.courriel' | translate }}</th>
        <td mat-cell
          *matCellDef="let element"> {{ element.adrCourriel }} </td>
      </ng-container>

      <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
        *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div class="no-data-message mb-3"
    *ngIf="dataSource.data && dataSource.data.length === 0">
    {{ 'sigt.global.messageAucuneDonnee' | translate }}
  </div>

  <div class="telecharger-container">
    <button mat-raised-button
      color="primary"
      type="button"
      (click)="telecharger()"
      [disabled]="isDownloading | async">
      {{ 'sigt.global.boutons.telecharger' | translate }}
    </button>
  </div>

  <mat-paginator [pageSizeOptions]="[25, 50, 100, 1000]"
    [pageSize]="25"
    [length]="tableState.pageLength"
    (page)="changerPage($event)"
    showFirstLastButtons></mat-paginator>
</div>